export const api = "https://content.japa.health/api/v1";
// export const api = "https://cckqgsc4-8080.inc1.devtunnels.ms/api/v1";
export const wordpressApi = "https://japa.health/wp-json/wp/v2";

export const devapi = "https://apivitality.japa.health/api/v1";
export const assesementApi = "https://apivitality.japa.health/api/v1"

// export const devapi = "https://devapi.japa.health/api/v1";
// export const assesementApi = "https://devapi.japa.health/api/v1"

// export const devapi = "https://cckqgsc4-7000.inc1.devtunnels.ms/api/v1";
// export const assesementApi = "https://cckqgsc4-7000.inc1.devtunnels.ms/api/v1"
